interface FeedbackPanelProps {
  battery: number;
  temp: number;
  seconds: string;
  isOn: boolean;
  intensity: number;
  modeName: string;
  heating: boolean;
  heatTarget: number;
  spraying: boolean;
}

export default function FeedbackPanel({
  battery,
  temp,
  seconds,
  isOn,
  intensity,
  modeName,
  heating,
  heatTarget,
  spraying,
}: FeedbackPanelProps) {
  const batteryIcon =
    battery > 70 ? "ri-battery-2-fill" : battery > 30 ? "ri-battery-line" : "ri-battery-low-line";

  return (
    <div className="mt-3 rounded-xl border border-background-200 bg-background-100/60 p-3">
      <div className="mb-2 flex items-center justify-between">
        <p className="text-xs font-medium text-foreground-800">リアルタイム</p>
        <span className="flex items-center gap-1.5 text-[11px] text-foreground-500">
          <span
            className={`h-1.5 w-1.5 rounded-full ${isOn ? "animate-pulse bg-accent-500" : "bg-background-300"}`}
          />
          {isOn ? "動作中" : "スタンバイ"}
        </span>
      </div>

      {/* 即时状态提示 */}
      {(heating || spraying) && (
        <div className="mb-2 flex flex-wrap gap-1.5">
          {heating && (
            <span className="flex items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-800">
              <i className="ri-fire-line" /> 加熱中 {heatTarget}°C
            </span>
          )}
          {spraying && (
            <span className="flex items-center gap-1 rounded-full bg-primary-100 px-2 py-0.5 text-[11px] font-medium text-primary-700">
              <i className="ri-drop-line" /> 潤滑油 噴射中
            </span>
          )}
        </div>
      )}

      <div className="grid grid-cols-2 gap-1.5">
        <div className="rounded-lg bg-background-50 px-2.5 py-1.5">
          <p className="flex items-center gap-1 text-[11px] text-foreground-400">
            <i className="ri-battery-2-line" /> バッテリー
          </p>
          <p className="mt-0.5 flex items-center gap-1 text-base font-semibold text-foreground-900">
            <i className={`${batteryIcon} text-primary-600`} /> {Math.round(battery)}%
          </p>
        </div>
        <div className="rounded-lg bg-background-50 px-2.5 py-1.5">
          <p className="flex items-center gap-1 text-[11px] text-foreground-400">
            <i className={heating ? "ri-fire-line text-accent-500" : "ri-temp-hot-line"} /> 温度
          </p>
          <p className="mt-0.5 flex items-baseline gap-1 text-base font-semibold text-foreground-900">
            {Math.round(temp)}°C
            {heating && (
              <span className="text-[11px] font-normal text-accent-600">→ {heatTarget}°</span>
            )}
          </p>
        </div>
        <div className="rounded-lg bg-background-50 px-2.5 py-1.5">
          <p className="flex items-center gap-1 text-[11px] text-foreground-400">
            <i className="ri-time-line" /> 経過時間
          </p>
          <p className="mt-0.5 font-mono text-base font-semibold tabular-nums text-foreground-900">{seconds}</p>
        </div>
        <div className="rounded-lg bg-background-50 px-2.5 py-1.5">
          <p className="flex items-center gap-1 text-[11px] text-foreground-400">
            <i className="ri-flashlight-line" /> 現在
          </p>
          <p className="mt-0.5 truncate text-sm font-semibold leading-6 text-foreground-900">
            {modeName} · {intensity}%
          </p>
        </div>
      </div>
    </div>
  );
}